export default __webpack_public_path__ + "static/media/util-dark.bf381cdf.svg";